import React, { useContext } from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../libs/Context';

const Moderation = (props) =>
{
	const { moderation, handleSet } = props;
	const { language } = useContext(LanguageContext);

	const handleChangeRadio = (event) =>
	{
		handleSet('moderation', Number(event.target.value));
	};

	return (
		<Grid item xs={12} alignItems='center' py='var(--pixel8)'>
			<Typography variant='inherit' fontSize='var(--pixel18)' fontWeight='var(--font500)'>
				{language?.moderation}
			</Typography>
			<RadioGroup value={moderation} onChange={handleChangeRadio}>
				<Stack direction={'row'} alignItems={'center'} py='var(--pixel8)' mr={0}>
					<FormControlLabel
						value={1}
						control={<Radio />}
						label={
							<Typography
								variant='body2'
								sx={{ borderRadius: 'var(--pixel4)', cursor: 'pointer', p: 'var(--pixel8)', width: 'var(--percent100)' }}
							>
								{language?.registrationInfo}
							</Typography>
						}
						sx={{ width: 'var(--percent100)' }}
					/>
				</Stack>
				<Stack direction={'row'} alignItems={'center'} py='var(--pixel8)' mr={0}>
					<FormControlLabel
						value={2}
						control={<Radio />}
						label={
							<Typography
								variant='body2'
								sx={{ borderRadius: 'var(--pixel4)', cursor: 'pointer', p: 'var(--pixel8)', width: 'var(--percent100)' }}
							>
								{language?.registrationInfo2}
							</Typography>
						}
						sx={{ width: 'var(--percent100)' }}
					/>
				</Stack>
			</RadioGroup>
		</Grid>
	);
};

export default Moderation;
